module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pf-fbd548e641a7199e969d252cf9d1eb18.svg";